const FONTS = {
  primary: "'Montserrat', Helvetica, sans-serif",
  secondary: 'Viga, Verdana',
  WEIGHT: {
    LIGHT: 300,
    NORMAL: 400,
    BOLD: 600,
    EXTRABOLD: 800,
  },
}

export default FONTS
